import React, { useState, useEffect } from "react";
import { useDispatch, shallowEqual, useSelector } from "react-redux";
import { useParams, useHistory } from "react-router-dom";
import * as actions from "./_redux/Actions";
import { useSubheader } from "../../../_metronic/layout";
import { ErrorMessage } from "formik";
import { NotificationManager } from "react-notifications";
import {
    Card,
    CardBody,
    CardHeader,
    ModalProgressBar, Input
} from "../../../_metronic/_partials/controls";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";

import Upload from "../../components/upload/Upload";
import DropdownReactSelect from "../../components/DropdownReactSelect";
import helperFunc from "../../../_metronic/_helpers/helperFunc";
import "../Game/AddGame/formcontrol.css";
import "../../../_metronic/_assets/sass/customstyle.react.scss";
const CommonForm = (props) => {
    const suhbeader = useSubheader();
    const dispatch = useDispatch();
    const [title, setTitle] = useState("");
    const [file, setFile] = useState(undefined);
    const { id } = useParams();
    let history = useHistory();
    const [
        companySelectedDropdownFilterData,
        setCompanySelectedDropdownFilterData,
      ] = useState(null);
      const [companyDropdownFilterData, setCompanyDropdownFilterData] = useState(
        []
      );
    const [frmInitialValues, setFrmInitialValues] = useState(
        {
            name: '',
            code: '',
            order: '',
            featuredImage: '',
            isActive: true,
            isDirect: false,
            link: ''

        }
    );

    const H5CategoryEditSchema = Yup.object().shape({
        // ...other fields...
        name: Yup.string()
            .required("Name is required"),
        code: Yup.string()
            .required("Code is required"),
        order: Yup.number()
            .required("Order is required"),
    });

    const { currentState } = useSelector(
        (state) => ({ currentState: state.H5categories }),
        shallowEqual
    );
    const { actionsLoading, H5categoryForEdit, company } = currentState
    useEffect(() => {
        dispatch(actions.fetchCompanyList());
      }, []);
    
      useEffect(() => {
        let tempb = [];
        const userdata = JSON.parse(localStorage.getItem("userData"));
        const userCompany = userdata?.company || [];
    
        for (let i = 0; i < company.length; i++) {
        //   if (!helperFunc.isAdmin()) {
            if (userCompany.includes(company[i]._id)) {
              let obj = {};
              obj.label = company[i].name;
              obj.value = company[i]._id;
              obj.code = company[i].code;
              tempb.push(obj);
            }
        //   } else {
        //     let obj = {};
        //     obj.label = company[i].name;
        //     obj.value = company[i]._id;
        //     obj.code = company[i].code;
        //     tempb.push(obj);
        //   }
        }
    
        setCompanyDropdownFilterData(tempb);
      }, [company]);
    useEffect(() => {
        dispatch(actions.fetchSingle(id));
    }, [id, dispatch]);

    useEffect(() => {
        let _title = id ? "" : "New Html5 Categories";
        if (H5categoryForEdit && id) {
            _title = `Edit Html5 Categories '${H5categoryForEdit.item && H5categoryForEdit.item.name}'`;
            const item = H5categoryForEdit.item!=null ?H5categoryForEdit.item : H5categoryForEdit.data
            const data = { ...frmInitialValues, ...item };
            setFile(item && item.featuredImage);
            setFrmInitialValues(data);
            let cdtata= companyDropdownFilterData.filter(cd => cd.code.includes(H5categoryForEdit?.company.code))
            console.log("cdtata",cdtata)
            setCompanySelectedDropdownFilterData(cdtata)

        } else {
            setFile(undefined);
        }
        setTitle(_title);
        suhbeader.setTitle(_title);
    }, [H5categoryForEdit, id]);

    const onUpdateFileValue = (file) => {
        setFile(file.image)
    }
    const saveLevel = async (values) => {
        const errorMessages = [];
    
        if (!values.name) {
            errorMessages.push('Please enter a Name');
        }
    
        if (!values.code) {
            errorMessages.push('Please enter a Code');
        }
        if (!values.order) {
            errorMessages.push('Please enter a order');
        }
        if (!companySelectedDropdownFilterData) {
            errorMessages.push('Please select a Company');
        }
    
        if (!file) {
            errorMessages.push('Please upload Image');
        }
    
        if (errorMessages.length > 0) {
            // Display each error message separately
            errorMessages.forEach((errorMessage) => {
                NotificationManager.error(errorMessage, 'Error');
            });
            return;
        }
    
        values.featuredImage = file;
    
        if (companySelectedDropdownFilterData?.code) {
            values.company = companySelectedDropdownFilterData?.code;
        } else if (companySelectedDropdownFilterData.length > 0 && companySelectedDropdownFilterData[0]?.code) {
            values.company = companySelectedDropdownFilterData[0]?.code;
        }
    
        try {
            // API call
            if (!id) {
              const success = await dispatch(actions.createItem(values));
              if (!success) {
                // If API call fails, do not redirect
                return;
              }
              // NotificationManager.success("Blog created successfully", "Success");
              setTimeout(backToList, 2000);// Navigate back if the API call was successful
            } else {
              const success = await dispatch(actions.updateItem(values));
              if (!success) {
                // If API call fails, do not redirect
                return;
              }
              // NotificationManager.success("Blog updated successfully", "Success");
              setTimeout(backToList, 2000);
              // Update item logic
            }
          } catch (error) {
            NotificationManager.error("Failed to save data", "Error");
          }
      };
    
    
    const backToList = () => {
        history.push(`/html5-categories/list`);
        window.location.reload();
    };

    return (
        <Card>
            {actionsLoading && <ModalProgressBar />}
            <CardHeader title={title}></CardHeader>
            <CardBody>
                <Formik
                    enableReinitialize={true}
                    initialValues={frmInitialValues}
                    validationSchema={H5CategoryEditSchema}
                    
                    onSubmit={(values) => {
                        console.log("Save button press")
                        console.log("Values :::", values)
                        saveLevel(values);
                    }}
                >
                    {({ handleSubmit, values }) => (
                        <Form className="form form-label-right">
                            <div className="form-group row">
                            <div className="col-lg-4 col-md-6 mt-2">
                                <label>
                                    Select Company{" "}
                                    <span style={{ color: "red", marginLeft: "3px" }}>*</span>
                                </label>
                                {console.log("testttt", frmInitialValues)}
                                <DropdownReactSelect
                                    placeholder={"Select Company"}
                                    name={"companies"}
                                    value={companySelectedDropdownFilterData}
                                    isMulti={false}
                                    isClearable={true}
                                    isSearchable={true}
                                    closeMenuOnSelect={true}
                                    options={companyDropdownFilterData}
                                    onChange={setCompanySelectedDropdownFilterData}
                                />
                            </div>
                                <div className="col-lg-4 col-md-6 mt-2">
                                    <Field
                                    //  className="form-controll"
                                        name="name"
                                        component={Input}
                                        placeholder="Name"
                                        label="Name"
                                        isRequired={true}
                                    />
                                </div>
                                <div className="col-lg-4 col-md-6 mt-2">
                                    <Field
                                    //  className="form-controll"
                                        name="code"
                                        component={Input}
                                        placeholder="Code"
                                        label="Code"
                                        isRequired={true}
                                    />
                                </div>
                                <div className="col-lg-4 col-md-6 mt-2">
                                    <Field
                                    //  className="form-controll"
                                        name="adjustName"
                                        component={Input}
                                        placeholder="Adjust Name"
                                        label="Adjust Name"
                                        // isRequired={true}
                                    />
                                </div>
                                <div className="col-lg-4 col-md-6 mt-2">
                                    <Field
                                    //  className="form-controll"
                                        name="order"
                                        component={Input}
                                        type="number"
                                        placeholder="Order"
                                        label="Order"
                                        isRequired={true}
                                    />
                                </div>
                                <div className="col-lg-2">
                                    <div>
                                    <label className="col-form-label">Is Active</label>
                                    <div className="col-10 w-90 p-0">
                                        <span className="switch switch-primary switch-icon">
                                            <label>
                                                <Field type="checkbox" name="isActive" />
                                                <span></span>
                                            </label>
                                        </span>
                                    </div>
                                    </div>
                                </div>
                                <div className="col-lg-2">
                                    
                                    <label className="col-form-label">Is Direct</label>
                                    <div className="col-10 w-80 mr-1 p-0">
                                        <span className="switch switch-primary switch-icon">
                                            <label>
                                                <Field type="checkbox" name="isDirect" />
                                                <span></span>
                                            </label>
                                        </span>
                                    </div>
                                </div>
                                {values.isDirect && (
                                    <div className="col-lg-3 l-4">
                                        {/* <Field
                                            name="link"
                                            component={Input}
                                            placeholder="Link"
                                            label="Link"
                                        /> */}
                                        <Field
                                            className="form-controll"
                                            name="link"
                                            component={Input}
                                            type="url"
                                            placeholder="Link"
                                            label="Link"
                                        />
                                        {/* <ErrorMessage name="link" component="div" className="text-danger" /> */}
                                    </div>
                                )}
                            </div>
                           
                            <div className="form-group row">
                                <div className="col-lg-4">
                                    <Field
                                        name="featuredImage"
                                        component={Upload}
                                        label="Image"
                                        file={file}
                                        onfileValueSet={onUpdateFileValue}
                                        isRequired={true}
                                    />
                                </div>
                            </div>
                            <div className="form-group justify-content-end row mx-0">
                                <button
                                    type="button"
                                    onClick={backToList}
                                    className="btn btn-light"
                                >
                                    <i className="fa fa-arrow-left"></i>Back
                                </button>
                                <button
                                    type="submit"
                                    className="btn btn-primary ml-2"
                                > {id ? "Update" : "Save"}</button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </CardBody>
        </Card>
    )
}
export default CommonForm;